module.exports = __webpack_public_path__ + "img/support_icon.8f3cfa54.svg";